<div class="relative flex items-center w-full max-w-sm min-w-[180px]">
  <i class="fi fi-rr-search absolute left-4 text-gray text-xl leading-none pt-[1px] flex items-center justify-center"></i>
  <input
    type="text"
    class="w-full pl-12 pr-4 py-3 min-h-12 rounded-2xl border leading-none border-soft-gray focus:outline-none placeholder:text-text-placeholder text-base"
    [placeholder]="placeholder"
    (input)="onInput($event)"
  />
</div>
